import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { MsgService } from 'app/main/components/msg/msg.service';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private _apiUrl = environment.appUrl;

  constructor(
    private _httpClient: HttpClient,
    private _msg: MsgService,
    private _progress: FuseProgressBarService
  ) { }

  changeApiUrl(newApiUrl: string): void {
    this._apiUrl = newApiUrl;
  }

  getObservable(apiModuleUrl: string): Observable<any[] | any>  {
    return this._httpClient
      .get<any[] | any>(this._apiUrl + apiModuleUrl);
  }

  get(apiModuleUrl: string, subject: BehaviorSubject<any[]>, url: string = ''): Promise<any> {
    this._progress.show();
    this.changeApiUrl((url !== '') ? url : environment.appUrl);

    return new Promise<any>((accept, reject) => {
      this._httpClient
        .get<any[]>(this._apiUrl + apiModuleUrl)
        .subscribe(x => {
          this._progress.hide();
          if (subject) {
            subject.next(x);
          }
          accept(x);
        }, e => {
          this._exceptionHandler(e);
          reject(e);
        });
    });
  }

  post(apiModuleUrl: string, body: any, url: string = ''): Promise<any> {
    this._progress.show();
    this.changeApiUrl((url !== '') ? url : environment.appUrl);

    return new Promise<any>((accept, reject) => {
      this._httpClient
        .post<any>(
          this._apiUrl + apiModuleUrl
          , body
          , { headers: new HttpHeaders({ 'Content-Type': 'application/json', }) })
        .subscribe(c => {
          this._progress.hide();
          accept(c);
        }, e => {
          this._exceptionHandler(e);
          reject(e);
        });
    });
  }

  delete(apiModuleUrl: string, id: number, url: string = ''): Promise<any> {
    this._progress.show();
    this.changeApiUrl((url !== '') ? url : environment.appUrl);

    return new Promise<any>((accept, reject) => {
      this._httpClient
        .delete<any>(
          `${this._apiUrl}${apiModuleUrl}/${id}`
          , { headers: new HttpHeaders({ 'Content-Type': 'application/json', }) })
        .subscribe(c => {
          this._progress.hide();
          accept(c);
        }, e => {
          this._exceptionHandler(e);
          reject(e);
        });
    });

  }

  getFullPromise(apiModuleUrl: string, url: string = ''): Promise<any> {
    let targetUrl = (url != '') ? url : environment.appUrl;
    this._progress.show();
    return new Promise<any>((accept, reject) => {
      this._httpClient
        .get<any>(`${targetUrl}${apiModuleUrl}`, { observe: 'response' })
        .subscribe((c: HttpResponse<any>) => {
          this._progress.hide();
          accept(c);
        }, e => {
          this._exceptionHandler(e);
          accept(e);
        });
    });
  }

  resolver(promises: Promise<any>[]): Observable<any> | Promise<any> | any {
    return new Promise((resolve, reject) => {
      Promise.all(promises).then(
        () => {
          resolve();
        }, reject
      );
    });
  }

  private _exceptionHandler(e: any): void {
    this._progress.hide();
    let errorMessage = '';

    if (e.error && e.error.exceptionMessage) {
      errorMessage = `${e.error.exceptionMessage}`;
    }
    else if (e.statusText === 'Unknown Error') {
      errorMessage = 'Ocurrio un error inesperado, comunicate con el administrador.';
    }
    this._msg.error(errorMessage);
  }
}
